module.exports = __webpack_public_path__ + "img/add.34c9cce3.jpg";